import React from "react";
import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function Disclaimer() {
  const { t } = useT();
  return (
    <section
      id="disclaimer"
      data-testid="disclaimer-section"
      className="py-20 sm:py-24 bg-[#EDEDEE]"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="rounded-[2rem] bg-[#F8F7F3] p-8 sm:p-12 border border-[#BCB3A6]/40"
        >
          <div className="flex items-start gap-5 mb-6">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#3F5043] flex items-center justify-center">
              <ShieldAlert size={20} className="text-[#F8F7F3]" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-[#899480] font-semibold mb-2">
                {t("disc.eyebrow")}
              </div>
              <h2 className="font-serif text-3xl sm:text-4xl font-light text-[#3F5043] leading-tight">
                {t("disc.title")}
              </h2>
            </div>
          </div>

          <div className="space-y-4 text-sm sm:text-base leading-relaxed text-[#3F5043]/85 mt-7 sm:pl-[68px]">
            <p>{t("disc.p1")}</p>
            <p>{t("disc.p2")}</p>
            <p className="font-semibold text-[#3F5043]">{t("disc.intro")}</p>
            <ul className="list-disc pl-6 space-y-2 text-[#3F5043]/85">
              <li>{t("disc.b1")}</li>
              <li>{t("disc.b2")}</li>
              <li>{t("disc.b3")}</li>
            </ul>
            <p>{t("disc.p3")}</p>
            <p className="text-xs uppercase tracking-[0.2em] text-[#875F45] font-semibold pt-2">
              {t("disc.note")}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
